import { render, staticRenderFns } from "./EcHome.vue?vue&type=template&id=6da9d79e&scoped=true"
import script from "./EcHome.vue?vue&type=script&lang=js"
export * from "./EcHome.vue?vue&type=script&lang=js"
import style0 from "./EcHome.vue?vue&type=style&index=0&id=6da9d79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9d79e",
  null
  
)

export default component.exports